{
    "actions": {
        "page": {
            "add_user": "Nouvel utilisateur monétique"
        },
        "row": {
            "activate": "Réactiver",
            "deactivate": "Désactiver",
            "reset_password": "Renvoyer mail activ.",
            "remove": "Supprimer",
            "connect_as": "Se connecter",
            "permissions_update": "Modifier permissions",
            "historics_access": "Historique de l'utilisateur"
        }
    },
    "filter": {
        "placeholder": {
            "email": "Filtrer par email"
        }
    },
    "keys": {
        "status": "Statut",
        "email": "Email",
        "profile": "Profil",
        "has_mfa": "A2F",
        "last_login_at": "Connecté le",
        "created_at": "Créé le",
        "updated_at": "MAJ le"
    },
    "has_mfa": {
        "false": "Non",
        "true": "Oui",
        "ENABLED": "Activé",
        "DISABLED": "Désactivé"
    },
    "modal": {
        "send_mail": {
            "title": "Nouvel utilisateur monétique",
            "emails": "Un lien de connexion sera envoyé par mail",
            "link_validity": "Le lien est valide pendant 72 heures",
            "success": "Utilisateur créé avec succès !",
            "maximum_mails": "(5 adresses mail maximum)",
            "placeholder": "Entrer une adresse ici...",
            "already_exists": "Ce mail existe déjà !",
            "confirmation": "Le mail va être envoyé au destinataire suivant :",
            "confirmation_users": "Le mail va être envoyé aux destinataires suivants :",
            "validate": "Validez pour terminer",
            "add_address": "Ajouter une adresse",
            "remove_address": "Effacer cette adresse",
            "steps": {
                "set_users": "Étape {{step}} sur {{maxStep}} : Ajout des email et des profils",
                "confirmation": "Étape {{step}} sur {{maxStep}} : Confirmation"
            }
        },
        "reset_password": {
            "title": "Réinitialisation du mot de passe",
            "text": "Un mail va être envoyé au destinataire suivant. Il recevra un lien pour réinitialiser son mot de passe.",
            "warning": "Le lien est valide pendant 72 heures.",
            "success": "Un mail a été envoyé à l'adresse suivante : {{userEmail}}",
            "error": "Une erreur est survenue."
        },
        "remove_user": {
            "title": "Supprimer l'utilisateur",
            "text": "Vous êtes sur le point de supprimer cet utilisateur.",
            "warning": "Veuillez confirmer la suppression.",
            "success": "L'utilisateur {{userEmail}} a bien été supprimé",
            "error": "Une erreur est survenue."
        },
        "permissions_update": {
            "title": "Modifier les permissions",
            "profile": "Profil",
            "permissions": "Permissions ({{number}})",
            "reset": "Réinitialiser les permissions du profil",
            "show_all": "Afficher tout",
            "success": "Permissions modifiées avec succès !",
            "error": "Une erreur est survenue lors de la modification des permissions."
        }
    },
    "permissions": {
        "title": "Permissions",
        "module": {
            "SUBSCRIPTION": "Abonnements",
            "CONTRACTS_ACCESS": "Comptes marchand",
            "MERCHANT_CONTRACT": "Contrats",
            "EXPORT": "Exports",
            "SUBSCRIPTION_PLAN": "Offres",
            "ORGANIZATION": "Organisations",
            "PAYMENT": "Remises",
            "SIM": "Cartes SIM",
            "POS_TERMINAL": "Terminaux",
            "USER": "Utilisateurs",
            "ENVELOPES": "Enveloppes",
            "PUSH_PAYMENT": "Push Payment API",
            "REMOTE_COLLECTIONS": "Remises",
            "TRANSACTIONS": "Transactions",
            "SETTINGS": "Configuration",
            "HYBRID": "Monétique Hybride",
            "HISTORICS": "Historiques"
        },
        "SUBSCRIPTION_READ": "Consulter les détails",
        "SUBSCRIPTION_LIST": "Lister",
        "SUBSCRIPTION_CONNECTION_POINTS_READ": "Lister les points de connexion (blocage)",
        "SUBSCRIPTION_CREATE": "Créer manuellement",
        "SUBSCRIPTION_ACTIVATE": "Activer",
        "SUBSCRIPTION_MIGRATE": "Changer la date de facturation",
        "SUBSCRIPTION_TERMINATE": "Résilier",
        "SUBSCRIPTION_REWAREHOUSE": "Remettre en stock",
        "SUBSCRIPTION_UPDATE": "Modifier le libellé",
        "MODIFY_IP_OFFER": "Modifier l'offre IP",
        "BLACKLIST_ADD_ENTRY": "Bloquer les TPE",
        "BLACKLIST_REMOVE_ENTRY": "Autoriser un TPE",
        "CONTRACTS_ACCESS_LIST": "Lister",
        "CONTRACTS_ACCESS_READ": "Consulter les détails",
        "CONTRACTS_ACCESS_CREATE": "Création comptes marchand",
        "CONTRACTS_ACCESS_CREATE_CONTRACT_PROFILE": "Affecter des contrats",
        "CONTRACTS_ACCESS_CREATE_USER": "Ajouter un utilisateur",
        "CONTRACTS_ACCESS_ACTIVATE": "Activer",
        "CONTRACTS_ACCESS_DEACTIVATE": "Désactiver",
        "CONTRACTS_ACCESS_UPDATE_CONTRACT_PROFILE": "Modifier le libellé d’un contrat",
        "CONTRACTS_ACCESS_UPDATE": "Modifier le libellé d’un compte marchand",
        "CONTRACTS_ACCESS_DELETE_CONTRACT_PROFILE": "Supprimer un contrat",
        "CSV_ADD_CONTRACTS_ACCESS": "Créer des comptes marchand par fichier CSV",
        "ALMA_ENTER_API_KEY": "Ajouter une clé d'API Alma",
        "MERCHANT_CONTRACT_READ": "Consulter les détails",
        "MERCHANT_CONTRACT_LIST": "Lister les contrats d'un TPE",
        "MERCHANT_CONTRACT_LIST_FROM_DIRECT_PROVIDER": "Lister les contrats du parc",
        "MERCHANT_CONTRACT_LIST_FROM_PROVIDER": "Lister",
        "MERCHANT_CONTRACT_CREATE": "Créer manuellement",
        "MERCHANT_CONTRACT_UPDATE": "Modifier le libellé",
        "CSV_ADD_CONTRACT_PROFILE": "Ajouter des contrats par fichier CSV",
        "MERCHANT_CONTRACT_EXPORT": "Exporter les contrats",
        "EXPORT_REMOTE_COLLECTIONS": "Exporter les remises",
        "EXPORT_SUBSCRIPTIONS": "Exporter les abonnements",
        "EXPORT_SIMS": "Exporter les SIMs",
        "EXPORT_ORGANIZATIONS": "Exporter les organisations",
        "EXPORT_CONTRACTS": "Exporter les contrats d'un compte marchand",
        "EXPORT_CONTRACTS_ACCESSES": "Exporter les comptes marchand",
        "EXPORT_MONETICS_USERS": "Exporter les utilisateurs monéticiens",
        "EXPORT_HISTORY": "Exporter les historiques",
        "PUSH_PAYMENT_EXPORT": "Exporter les règles",
        "EXPORT_POS_TERMINAL_TRANSACTIONS": "Exporter les transactions d'un TPE",
        "EXPORT_POS_TERMINAL_REMOTE_COLLECTIONS": "Exporter les télécollectes d'un TPE",
        "EXPORT_PAYLUDD_POS_TERMINALS": "Exporter les terminaux Payludd",
        "COMPANY_INFOS_READ": "Récupérer les informations d'un SIRET",
        "SUBSCRIPTION_PLAN_READ": "Consulter les détails",
        "SUBSCRIPTION_PLAN_LIST_CLIENT_PLANS": "Lister les offres d'un client",
        "SUBSCRIPTION_PLAN_LIST_PROVIDER_PLANS": "Lister les offres fournisseurs",
        "SUBSCRIPTION_PLAN_LIST_ALLOWED_CLIENTS_FOR_CLIENT_PLAN": "Lister les clients autorisés",
        "SUBSCRIPTION_PLAN_CREATE": "Créer",
        "SUBSCRIPTION_PLAN_ADD_CLIENT": "Ajouter un client à une offre",
        "SUBSCRIPTION_PLAN_DELETE_CLIENT": "Retirer une offre à un client",
        "SUBSCRIPTION_PLAN_UPDATE": "Modifier",
        "ORGANIZATION_READ": "Consulter les détails",
        "ORGANIZATION_LIST": "Lister",
        "ORGANIZATION_CREATE": "Créer une organisation",
        "ORGANIZATION_CREATE_CLIENT_ORGANIZATION": "Créer une sous-organisation",
        "ORGANIZATION_UPDATE": "Modifier une organisation",
        "ORGANIZATION_UPDATE_SHOULD_BLOCK_NEW_POS": "Bloquer les nouveaux TPE",
        "ORGANIZATION_UPDATE_ALERT_POS": "Paramétrer les alertes par mail",
        "ORGANIZATION_GET_ALERT_POS": "Consulter les alertes par mail",
        "ORGANIZATION_GET_ALERT_SIMS": "Consulter les alertes SIMs",
        "ORGANIZATION_UPDATE_ALERT_SIMS": "Paramétrer les alertes SIMs",
        "CHANGE_ORGANIZATION_SIM_OFFER": "Gérer les forfaits",
        "PAYMENT_LIST_TERMINAL_REMOTE_COLLECTIONS": "Lister les remises d'un TPE",
        "PAYMENT_LIST_TERMINAL_TRANSACTIONS": "Lister les transactions d'un TPE",
        "PAYMENT_LIST_REMOTE_COLLECTIONS": "Lister les remises du parc",
        "PAYMENT_LIST_REMOTE_COLLECTION_TRANSACTIONS": "Lister les transactions d'une remise",
        "PAYMENT_READ_PLBS_DETAILS": "Récupérer les détails d'un dossier PLBS",
        "PAYMENT_LIST_REMOTE_COLLECTION_PLBS": "Lister les dossiers PLBS d'une remise",
        "PAYMENT_SEND_REMOTE_COLLECTION_NOTIFICATION": "Envoyer un ticket de remise",
        "PAYMENT_SEND_TRANSACTION_NOTIFICATION": "Envoyer un ticket de transaction",
        "SIM_READ": "Consulter les détails",
        "SIM_LIST": "Lister",
        "SIM_PASS_ORDER": "Passer une commande",
        "SIM_CREATE_SUBSCRIPTION": "Ajouter des SIMs à un client",
        "SIM_ACTIVATE": "Activer",
        "SIM_UPDATE": "Modifier",
        "SIM_GET_STATUS_FROM_ICCID": "Récupérer les statuts des SIMs",
        "SIM_SIERRA_OFFER_LIST": "Lister les offres Sierra Wireless",
        "SIM_IMPORT_FROM_ORDER": "Importer des SIMs Sierra Wireless",
        "SIM_ASSOCIATE": "Lier des SIMs existantes à un client",
        "SIM_SUSPEND": "Suspendre",
        "SIM_REPLACE": "Remplacer",
        "SIM_TERMINATE": "Résilier",
        "SIM_RESUME": "Réactiver",
        "SIM_IMPORT_CSV": "Importer des SIMs via CSV",
        "SIM_REASSIGN": "Réaffecter / désaffecter",
        "UPGRADE_SIM_OFFER": "Modifier le forfait",
        "GET_ORGANIZATION_SIM_OFFERS": "Lister les forfaits",
        "MB_ADMIN": "Modifier les marques blanches",
        "MB_PERSONALIZE": "Modifier la personnalisation",
        "GET_OFFERS_FOR_SIM": "Lister les forfaits",
        "POS_TERMINAL_READ": "Consulter les détails",
        "POS_TERMINAL_LIST_EVENT_LOGS": "Lister les connexions",
        "POS_TERMINAL_CREATE": "Créer",
        "POS_TERMINAL_UPDATE": "Mettre à jour",
        "GET_GEOLOCATION": "Montrer la géolocalisation",
        "USER_READ": "Consulter les détails",
        "USER_CREATE": "Créer / Modifier",
        "USER_ACTIVATE": "Activer",
        "USER_DEACTIVATE": "Désactiver",
        "USER_RESEND_ACTIVATION_MAIL": "Renvoyer un mail d'activation",
        "USER_LIST": "Lister",
        "USER_REMOVE": "Supprimer",
        "USER_LOGIN_AS_USER": "Se connecter en tant que",
        "LIST_REMOTE_DOWNLOADS": "Lister",
        "EXPORT_REMOTE_DOWNLOADS": "Exporter les enveloppes",
        "CSV_INSERT_POS_REMOTE_DOWNLOAD": "Créer",
        "DELETE_REMOTE_DOWNLOADS": "Déprogrammer",
        "PUSH_PAYMENT_READ": "Lister les organisations partenaires et les règles de notifications",
        "PUSH_PAYMENT_UPDATE": "Modifier le libellé",
        "PUSH_PAYMENT_DELETE": "Supprimer une règle de notification",
        "PUSH_PAYMENT_IMPORT": "Créer/Supprimer des règles via CSV",
        "VISUALISE_POS_TERMINAL_STATUS_ON_GATEWAY": "Visualiser le statut sur la passerelle",
        "MERCHANT_EXPORT_REMOTE_COLLECTIONS": "Exporter les remises",
        "MERCHANT_EXPORT_GLOBAL_TRANSACTIONS": "Exporter les transactions",
        "MERCHANT_PAYMENT_LIST_REMOTE_COLLECTIONS": "Lister les remises du parc",
        "MERCHANT_PAYMENT_LIST_REMOTE_COLLECTION_TRANSACTIONS": "Lister les transactions d'une remise",
        "MERCHANT_PAYMENT_SEND_REMOTE_COLLECTION_NOTIFICATION": "Envoyer un ticket de télécollecte",
        "MERCHANT_PAYMENT_LIST_GLOBAL_TRANSACTIONS": "Lister les transactions du parc",
        "MERCHANT_PAYMENT_SEND_TRANSACTION_NOTIFICATION": "Envoyer le ticket porteur",
        "MERCHANT_PAYMENT_READ_MERCHANT_TICKET": "Afficher/Exporter le ticket marchand",
        "MERCHANT_SHOP_MANAGEMENT": "Gérer les groupes",
        "MERCHANT_SHOP_READ": "Visualiser les groupes",
        "MERCHANT_POS_LABEL_UPDATE": "Modifier le libellé d'un TPE",
        "ANDROID_MANAGE_PACKAGE": "Personnaliser TPE Android",
        "TRANSACTIONS_EMERGENCY_REMOTE": "Télécollecte de secours",
        "LIST_HISTORY": "Lister",
        "SCHEDULED_EXPORT_MERCHANT_REMOTE_COLLECTIONS": "Gérer les exports des remises",
        "SCHEDULED_EXPORT_MERCHANT_TRANSACTIONS": "Gérer les exports des transactions",
        "MERCHANT_EXPORT_PAYMENT_LIST_TRANSACTIONS_WITH_TIPS": "Exporter les pourboires",
        "MERCHANT_PAYMENT_LIST_TRANSACTIONS_WITH_TIPS": "Lister les pourboires",
        "MERCHANT_TRANSACTIONS_REFUND": "Rembourser"
    },
    "profile": {
        "PROFILE_ADMIN": "Administrateur",
        "PROFILE_READ_ONLY": "Lecture seule",
        "PROFILE_SIM_AND_TERMINAL_MANAGER": "Gestion TPE-SIM",
        "PROFILE_HOTLINE": "Support"
    },
    "status": {
        "ACTIVE": "Activé",
        "INACTIVE": "Désactivé"
    },
    "toast": {
        "success": {
            "activate": "Réactivation de l'utilisateur réussie",
            "deactivate": "Désactivation de l'utilisateur réussie"
        },
        "error": {
            "activate": "Réactivation de l'utilisateur interrompue",
            "deactivate": "Désactivation de l'utilisateur interrompue"
        }
    },
    "tooltip": {
        "has_mfa": "Authentification à double facteur"
    }
}